module.exports = __webpack_public_path__ + "img/unicredit-mediumitalic.e57afa0a.svg";